// drag-drop.directive.ts
import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[ImgDragDrop]',
})
export class DragDropDirective {
    @Output() fileDropped = new EventEmitter<File[]>();

    @HostBinding('style.background-color') private background = '#f9f9f9';
    @HostBinding('style.opacity') private opacity = '1';

    // Lista de tipos de archivos permitidos
    private allowedTypes = ['image/png', 'image/bmp', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'];

    // Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#e2eefd';
        this.opacity = '0.8';
    }

    // Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#f9f9f9';
        this.opacity = '1';
    }

    // Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt: any) {
        evt.preventDefault();
        evt.stopPropagation();
        this.background = '#f9f9f9';
        this.opacity = '1';
        const files = evt.dataTransfer.files;
        if (files.length > 0) {
            const validFiles = this.filterFiles(files);
            if (validFiles.length > 0) {
                this.fileDropped.emit(validFiles);
            }
        }
    }

    // Filtra los archivos según los tipos permitidos
    private filterFiles(files: FileList): File[] {
        const validFiles: File[] = [];
        for (let i = 0; i < files.length; i++) {
            const file = files.item(i);
            if (file && this.allowedTypes.includes(file.type)) {
                validFiles.push(file);
            }
        }
        return validFiles;
    }
}
